import formatInventories from './formatInventories'
import formatItems from './formatItems'
import setOOSProducts from './setOOSProducts'

const checkInventory = items => {
  const products = formatItems(items)
  const inventories = formatInventories(items)
  return setOOSProducts(inventories, products)
}

export default checkInventory
